
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { memo, useEffect } from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

// Using memo to prevent unnecessary re-renders
const ProtectedRoute: React.FC<ProtectedRouteProps> = memo(({ children }) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { isLoading: langLoading } = useLanguage();
  
  // Combined loading state
  const isLoading = authLoading || langLoading;
  
  // Log performance metrics to help identify bottlenecks
  useEffect(() => {
    const startTime = performance.now();
    
    return () => {
      const endTime = performance.now();
      console.log(`Protected route render time: ${endTime - startTime}ms`);
    };
  }, []);
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
});

ProtectedRoute.displayName = 'ProtectedRoute'; // For React DevTools

export default ProtectedRoute;
